export default {
  maxDate: null,
  loading: true,
  showTicketSelection: false,
  showContainerSidebar: false,

  isReservation: false,

  articles: {},

  orderReference: null,

  cartLoading: true,
  cart: {
    reservations: {
      count: 0,
      date: '',
      gap: 0
    },
    tickets: {
      articles: {},
      date: '',
      discount: 0,
      gap: 0,
      total: 0
    },
    tours: {
      articlels: {},
      date: ''
    },
    vouchers: {
      articles: {},
      total: 0
    },
    events: {
      articles: {},
      date: '',
      gap: 0,
      total: 0
    },
    ticketVoucher: {
      articles: {},
      total: 0
    },
    total: 0
  },

  selectedReservationsAmount: 0,
  selectedTicketsAmount: 0,

  ticketSelection: {
    selectedDate: '',
    maxTicketNumber: 14,
    tickets: []
  },

  vouchers: {},
  voucherSelection: {},

  isGiftcardOrder: false,
  giftCards: {},
  selectedGiftCard: null,
  selectedGiftCardTickets: {},
  selectedGiftCardTemplate: null,

  payments: [],

  labels: [],
  config: {},

  arrivalTable: {
    earliestGap: 1,
    latestGap: 30,
    openingGap: 1,

    previous: {
      date: '',
      selectable: true
    },
    active: {
      date: ''
    },
    next: {
      date: '',
      selectable: true
    }
  },

  gaps: {},

  tours: [],
  toursConfig: {},
  toursSpotsPerGap: {},
  toursSelectedTime: {},
  tourFilter: 0,

  events: {},
  eventTeaser: {},
  priceGroups: {},
  eventsByType: {},
  eventInformation: {},
  selectedEventTimes: {
    from: '',
    until: ''
  },

  yullbeSelectedClass: null
}
